import { render } from "./projectRecentFiles.vue?vue&type=template&id=4194520a&ts=true"
import script from "./projectRecentFiles.vue?vue&type=script&lang=ts"
export * from "./projectRecentFiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__